import { VariantProps, cva } from 'class-variance-authority';
import type { CommonProps } from '../../types';
import { twMerge } from 'tailwind-merge';
import { ButtonOrLink } from '../button-or-link';

export interface NavigationItemProps
    extends CommonProps,
        VariantProps<typeof NavigationItemStyles> {
    label: string;
    href?: string;
    isActive?: boolean;
}

export const NavigationItemStyles = cva(
    'group click-area flex items-center justify-center w-full border-b h-20 transition hover:border-b-white/100 hover:cursor-pointer',
    {
        variants: {
            isActive: {
                false: 'border-b-white/50',
                true: 'border-b-white/100',
            },
        },
        defaultVariants: {
            isActive: false,
        },
    }
);

export const NavigationItem = ({
    href,
    label,
    isActive,
    className,
    testId = 'navigation-item-info',
}: NavigationItemProps): JSX.Element => {
    return (
        <li className={twMerge(NavigationItemStyles({ isActive, className }))}>
            <ButtonOrLink
                className={`click-area-link text-lg transition group-hover:opacity-100 ${
                    isActive ? 'opacity-100' : 'opacity-50'
                }`}
                data-testid={testId}
                href={href}
                internal
            >
                {label}
            </ButtonOrLink>
        </li>
    );
};
